import type { AnalyticsPageViews } from '@bo-types/analytics';

export const RUDDERSTACK_LOAD_OPTIONS = {
  queueOptions: {
    maxItems: 2,
    maxAttempts: -1,
    minRetryDelay: 8640000,
    maxRetryDelay: 86400000,
    batch: {
      enabled: false
    }
  }
};

export const PAGE_VIEW: AnalyticsPageViews = {
  MEMBERS: {
    PARENT_VIEW: 'Members Search Page',
    DEPOSITS: 'Members Deposits Page',
    ENTRIES: 'Members Entries Page',
    PROFILE: 'Members Profile Page',
    PROMOTIONS: 'Members Promotions Page',
    NOTES: 'Members Notes Page',
    REFERRALS: 'Members Referrals Page',
    RESPONSIBLE_GAMING: 'Members Responsible Gaming Page',
    TRANSACTIONS: 'Members Transactions Page',
    WITHDRAWALS: 'Members Withdrawals Page'
  },
  PLAYER_PACKS: {
    PARENT_VIEW: 'Player Packs Page'
  },
  RESOLUTIONS: {
    PARENT_VIEW: 'Resolutions Page'
  },
  UNSETTLEMENTS: {
    PARENT_VIEW: 'Members Unsettlements Page'
  }
};
